export enum AnalysisState {
  inProgress = 'IN_PROGRESS',
  complete = 'COMPLETE'
}
